module.exports = __webpack_public_path__ + "static/media/mam.0379d56e.jfif";